<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 24 30" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M2.99987 19.5711V28.7141C2.99987 29.3451 2.48787 29.8571 1.85687 29.8571C1.22587 29.8571 0.713867 29.3451 0.713867 28.7141V1.28509C0.713867 0.65409 1.22587 0.14209 1.85687 0.14209C2.48787 0.14209 2.99987 0.65409 2.99987 1.28509H22.4289C23.0599 1.28509 23.5719 1.79709 23.5719 2.42809V18.4281C23.5719 19.0591 23.0599 19.5711 22.4289 19.5711H2.99987ZM7.57087 3.57109V8.14209H2.99987V12.7131H7.57087V17.2841H21.2849V3.57009L7.57087 3.57109ZM12.1429 3.57109H16.7139V8.14209H12.1429V3.57109ZM7.57087 8.14209L12.1419 8.14309V12.7141L7.57087 12.7131V8.14209ZM16.7139 8.14209L21.2849 8.14309V12.7141H16.7139V8.14209ZM12.1419 12.7141H16.7139V17.2851H12.1429L12.1419 12.7141Z"
	/>
</svg>
